import onError from './onError';

export default function setup() {
    // Keep a reference to any existing 'window.onerror' handler
    let originalOnError;
    if (window && window.onerror) {
        originalOnError = window.onerror;
    }

    // setup default onerror handler on window
    window.onerror = function() {
        let args = arguments;

        // call our own onerror handler
        onError.apply(this, (args as unknown) as [
            string,
            (string | undefined)?,
            (number | undefined)?,
            (number | undefined)?,
            any?
        ]);

        // call any original onerror handler we captured
        originalOnError && originalOnError.apply(this, args);
    };

    // setup error handler for when promises reject but don't get caught
    if ('onunhandledrejection' in window) {
        (<Window>window).addEventListener('unhandledrejection', function(
            event: PromiseRejectionEvent
        ) {
            let promiseReason =
                event && event.reason && event.reason !== '' ? event.reason : '[no reason given]';
            if (promiseReason instanceof Error) {
                onError('Unhandled Rejection: ' + promiseReason, '', 0, 0, promiseReason);
            } else if (typeof promiseReason === 'string') {
                onError('Unhandled Rejection: ' + promiseReason);
            } else {
                onError('Unhandled Rejection: ' + JSON.stringify(promiseReason));
            }
        });
    }
}
